import React from "react";
import styles from "./UserImage.module.scss";
import { ImageType } from "@/types/baseTypes";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";

interface UserImageProps extends React.HTMLAttributes<HTMLDivElement> {
  image: ImageType;
  skeleton?: boolean;
}

export const UserImage = ({ image, skeleton }: UserImageProps) => {
  const skeletonElementClass = skeleton ? "skeleton-element" : "";

  return (
    <MediaItemResponsive
      image_desktop={image}
      sizes="(max-width: 1023px) 100vw, (max-width: 1215x) 25vw, (max-width: 1533px) 33vw, 375px"
      objectFit="cover"
      className={`${skeletonElementClass} ${styles["image-wrapper"]} auto-height `}
    />
  );
};
